import { render, staticRenderFns } from "./ChangeSubmenuClick.vue?vue&type=template&id=804f0f48"
import script from "./ChangeSubmenuClick.vue?vue&type=script&lang=js"
export * from "./ChangeSubmenuClick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports